import DepositSingleToken from "./DepositSingleToken";

export default DepositSingleToken;
